// React Dependencies
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Loading from "../../../Components/Interactive/Loading";

import { useNavigate } from "react-router-dom";

import { logout } from "../../../Redux/Actions/userActions";

// Component Imports
import LatestLeadsTable from "./LatestLeads/LatestLeadsTable";

const Leads = ({ isOpen }) => {
  const [loading, setIsLoading] = useState(false);
  const [userLeads, setUserLeads] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await fetch(`/api/leads/`, {
        method: "GET",
        credentials: "include",
      });
      if (res.status === 401) {
        dispatch(logout());
        return navigate("/");
      }
      const result = await res.json();
      setUserLeads(result.result);
      setIsLoading(false);
    })();
  }, [dispatch, navigate]);

  return (
    <div className={`${isOpen ? "page" : "page-closed"} `}>
      <h3 className="heading">Latest Leads</h3>
      {loading && <Loading />}
      {userLeads && userLeads.length && <LatestLeadsTable leads={userLeads} />}
    </div>
  );
};

export default Leads;
